"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompletedIncomeReportType = exports.InProgressIncomeReportType = exports.PlaidIncomeReportRejectionReason = void 0;
var PlaidIncomeReportRejectionReason;
(function (PlaidIncomeReportRejectionReason) {
    PlaidIncomeReportRejectionReason["PLAID_NAME_MISMATCH"] = "PLAID_NAME_MISMATCH";
    PlaidIncomeReportRejectionReason["PLAID_NO_OWNER_NAMES"] = "PLAID_NO_OWNER_NAMES";
    PlaidIncomeReportRejectionReason["PLAID_DENY_LIST_INSTITUTION"] = "PLAID_DENY_LIST_INSTITUTION";
})(PlaidIncomeReportRejectionReason || (exports.PlaidIncomeReportRejectionReason = PlaidIncomeReportRejectionReason = {}));
var InProgressIncomeReportType;
(function (InProgressIncomeReportType) {
    InProgressIncomeReportType["inProgressPlaidDataReport"] = "inProgressPlaidDataReport";
    InProgressIncomeReportType["inProgressIrsFlow"] = "inProgressIrsFlow";
    InProgressIncomeReportType["inProgressDocumentUpload"] = "inProgressDocumentUpload";
})(InProgressIncomeReportType || (exports.InProgressIncomeReportType = InProgressIncomeReportType = {}));
var CompletedIncomeReportType;
(function (CompletedIncomeReportType) {
    CompletedIncomeReportType["completedPlaidDataReport"] = "completedPlaidDataReport";
    CompletedIncomeReportType["completedExperianDataReport"] = "completedExperianDataReport";
    CompletedIncomeReportType["completedWorkNumberDataReport"] = "completedWorkNumberDataReport";
    CompletedIncomeReportType["completedIrsDataReport"] = "completedIrsDataReport";
    CompletedIncomeReportType["completedManualIncomeVerification"] = "completedManualIncomeVerification";
    CompletedIncomeReportType["completedLlmIncomeDataReport"] = "completedLlmIncomeDataReport";
})(CompletedIncomeReportType || (exports.CompletedIncomeReportType = CompletedIncomeReportType = {}));
